export const ajaxListNovedades = () => {
    jQuery(document).ready(function ($) {

        let page = 1;
        let postsPerPage = 6;
        let isLoading = false;
        let canBeLoaded = true;
        let category = null;
        const sticky = document.querySelector('.hero').dataset.sticky;

        function load_posts() {
    
            if (isLoading === true || !canBeLoaded) return;
            isLoading = true;
            
            $('.loader-container').show();
    
            $.ajax({
                url: WP.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'load_more_posts',
                    category: category,
                    sticky: sticky,
                    page: page,
                    'posts_per_page': postsPerPage,
                    nonce: WP.nonce
                },
                success: function (response) {
                    isLoading = false;
    
                    if (response.success) {
                        let newPosts = $(response.data.posts);
                            $('#posts-list').append(newPosts);
    
                        if (newPosts.length < postsPerPage) {
                                canBeLoaded = false;
                            } else {
                                page++; 
                            }  
                    } else {
                        console.error('AJAX request error:', response);
                    }
                },
                error: function (xhr, textStatus, errorThrown) {
                    console.error('Error when making AJAX request', textStatus, errorThrown);
    
                },
                complete: function () {
                    $('.loader-container').hide();
                }
            });
        }
    
        $(window).scroll(function() {
            if ($(window).scrollTop() + $(window).height() >= $(document).height() - 400) {
                load_posts();
            }
        });
    
        load_posts();
    
        $('.category-button').click(function () {
            canBeLoaded = true;
            isLoading = false;
            page = 1;
            $('#posts-list').empty();
            category = $(this).data('category') || null;
            $('.category-button').removeClass('active');
            $(this).addClass('active');
            load_posts(category);
        });
    });
         
}

export const ajaxListOportunidades = () => {
    jQuery(document).ready(function ($) {

        let page = 1;
        const postsPerPage = 9;
        let isLoading = false;
        let canBeLoaded = true;
        const filter = {
            emprendimiento: [],
            tipologia: [],
            estado: [],
            orden: '0'
        };

        function load_posts(filter) {
            if (isLoading || !canBeLoaded) return;
            isLoading = true;

            $('.loader-container').show();
            console.log(filter.emprendimiento)
            console.log(filter.tipologia)
            console.log(filter.estado)
            $.ajax({
                url: WP.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'load_more_posts_oportunidades',
                    emprendimiento: filter.emprendimiento,
                    tipologia: filter.tipologia,
                    estado: filter.estado,
                    orden: filter.orden,
                    page: page,
                    posts_per_page: postsPerPage,
                    nonce: WP.nonce
                },
                success: function (response) {
                    isLoading = false;

                    if (response.success) {
                        const newPosts = $(response.data.posts);
                        console.log(newPosts.length)

                        $('#posts-list').append(newPosts);

                        if (newPosts.length < postsPerPage) {
                            canBeLoaded = false;
                        } else {
                            page++;
                        }
                    } else {
                        console.error('AJAX request error:', response);
                    }
                },
                error: function (xhr, textStatus, errorThrown) {
                    console.error('Error when making AJAX request', textStatus, errorThrown);
                },
                complete: function () {
                    $('.loader-container').hide();
                }
            });
        }

        $(window).scroll(function () {
            if ($(window).scrollTop() + $(window).height() >= $(document).height() - 400) {
                load_posts(filter);
            }
        });

        load_posts(filter);

        $('#btnFilter').click(function () {
            canBeLoaded = true;
            isLoading = false;
            page = 1;
            $('#posts-list').empty();

            filter.emprendimiento = $('#selectEmprendimientos').val() || [];
            filter.tipologia = $('#selectTipologias').val() || [];
            filter.estado = $('#selectEstado').val() || [];

            load_posts(filter);
        });

        $('#selectOrden').change(function () {
            filter.orden = $(this).val();
            canBeLoaded = true;
            isLoading = false;
            page = 1;
            $('#posts-list').empty();
            load_posts(filter);
        });

    });
};


export const ajaxListCategory = () => {
    jQuery(document).ready(function ($) {

        let page = 1;
        let postsPerPage = 6;
        let isLoading = false;
        let canBeLoaded = true;
        const category = document.querySelector('.category-button.active').dataset.category;
        const sticky = document.querySelector('.hero').dataset.sticky;
        
        function load_posts() {
    
            if (isLoading === true || !canBeLoaded) return;
            isLoading = true;
            
            $('.loader-container').show();
    
            $.ajax({
                url: WP.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'load_more_posts',
                    category: category,
                    sticky: sticky,
                    page: page,
                    'posts_per_page': postsPerPage,
                    nonce: WP.nonce
                },
                success: function (response) {
                    isLoading = false;
    
                    if (response.success) {
                        let newPosts = $(response.data.posts);
                            $('#posts-list').append(newPosts);
    
                        if (newPosts.length < postsPerPage) {
                                canBeLoaded = false;
                            } else {
                                page++; 
                            }  
                    } else {
                        console.error('AJAX request error:', response);
                    }
                },
                error: function (xhr, textStatus, errorThrown) {
                    console.error('Error when making AJAX request', textStatus, errorThrown);
    
                },
                complete: function () {
                    $('.loader-container').hide();
                }
            });
        }
    
        $(window).scroll(function() {
            if ($(window).scrollTop() + $(window).height() >= $(document).height() - 400) {
                load_posts();
            }
        });
    
        load_posts(category);

    });
         
}

